import React from 'react';
import PropTypes from 'prop-types';

import { CELL_TYPES } from '../../enums';
import Cell from '../Cell';

const LocationPricing = ({ active, adjusted, extended }) => {
  return (
    <>
      <Cell type={active ? CELL_TYPES.currency : CELL_TYPES.empty} alias={adjusted} disabled={!active} />
      <Cell type={active ? CELL_TYPES.currency : CELL_TYPES.empty} alias={extended} disabled={!active} />
    </>
  );
};

LocationPricing.propTypes = {
  active: PropTypes.bool,
  adjusted: PropTypes.string,
  extended: PropTypes.string,
};

LocationPricing.defaultProps = {
  active: true,
};

export default LocationPricing;
